var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHamburgerv2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "20px",
    viewBox: "0 0 26 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "hamburger") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "hamburger",
    transform: "translate(2.000000, 1.000000)",
    stroke: "#FFFFFF",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 0.529411765,
    x2: 22,
    y2: 0.529411765,
    id: "Path-2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 9,
    x2: 22,
    y2: 9,
    id: "Path-2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 17.4705882,
    x2: 22,
    y2: 17.4705882,
    id: "Path-2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburgerv2);
export default __webpack_public_path__ + "static/media/hamburger.v2.93af0a6bc994f74c6172c744a1fdc877.svg";
export { ForwardRef as ReactComponent };